import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import Dialog from '../../../components/dialog/Dialog';
import UI from '../../../constants/ui';

function StartAssessmentDialog(props) {
  const {
    isDialogOpen,
    primaryAction,
    secondaryAction,
    content,
    primaryLabel,
    secondaryLabel,
    isMockInterview,
  } = props;
  return (
    <Dialog
      title={isMockInterview ? UI.INTERVIEW_CONFIRM : UI.ASSESSMENT_CONFIRM}
      content={content}
      primaryLabel={primaryLabel}
      primaryAction={primaryAction}
      secondaryLabel={secondaryLabel}
      secondaryAction={secondaryAction}
      isDialogOpen={isDialogOpen}
    />
  );
}

StartAssessmentDialog.propTypes = {
  isDialogOpen: PropTypes.bool,
  primaryAction: PropTypes.func,
  secondaryAction: PropTypes.func,
  content: PropTypes.string,
  primaryLabel: PropTypes.string,
  secondaryLabel: PropTypes.string,
  isMockInterview: PropTypes.bool,
};

StartAssessmentDialog.defaultProps = {
  isDialogOpen: false,
  primaryAction: noop,
  secondaryAction: noop,
  content: undefined,
  primaryLabel: undefined,
  secondaryLabel: undefined,
  isMockInterview: false,
};

export default StartAssessmentDialog;
